var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('Drawer'),(_vm.authState !== 'signedin' && _vm.isGuestMode)?_c('div',[_vm._t("default")],2):_vm._e(),(!_vm.isGuestMode)?_c('div',[_c('amplify-authenticator',[_c('amplify-sign-in',{attrs:{"slot":"sign-in","hide-sign-up":"true"},slot:"sign-in"}),_vm._t("default")],2)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }